import { useQuery } from '@tanstack/react-query'

import { IFinancialAccount } from '@/types'
import { BankService } from '@/api/services/BankService'
import { connectionQueryKeys } from '@/api/services/connectionQueryKeys'

// One read per connection, shared by the list and anything else that needs its accounts.
export const useFinancialAccounts = (userId: string, connectionId: string) =>
  useQuery<IFinancialAccount[]>({
    queryKey: connectionQueryKeys.accounts(userId, connectionId),
    queryFn: () => BankService.fetchFinancialAccounts(userId, connectionId),
  })
